import { render, staticRenderFns } from "./teamGoods.vue?vue&type=template&id=136a0cce&scoped=true"
import script from "./teamGoods.vue?vue&type=script&lang=js"
export * from "./teamGoods.vue?vue&type=script&lang=js"
import style0 from "./teamGoods.vue?vue&type=style&index=0&id=136a0cce&prod&lang=css"
import style1 from "./teamGoods.vue?vue&type=style&index=1&id=136a0cce&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "136a0cce",
  null
  
)

export default component.exports